var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"hold-transition login-page"},[_c('div',{staticClass:"login-box"},[_c('h2',[_vm._v("404 - Not Found!")]),_c('br'),_c('router-link',{staticClass:"btn btn-default",attrs:{"to":"/"}},[_c('p',[_vm._v("Back to Home")])])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }